import { render, staticRenderFns } from "./ConfirmImportDialog.vue?vue&type=template&id=31b86538&scoped=true"
import script from "./ConfirmImportDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmImportDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmImportDialog.vue?vue&type=style&index=0&id=31b86538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b86538",
  null
  
)

export default component.exports